import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Tempotravelleronrentmumbai() {



  const cardData = {
    keyword: " Tempo Traveller On Rent Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and spacious Tempo Traveller on rent in Mumbai, making group travel easy, comfortable, and stress-free for families, corporate trips, weddings, airport transfers, and outstation journeys. Our Tempo Travellers are available in multiple seating options such as 9, 12, 17, 20, and 26 seater models, equipped with comfortable pushback seats, air-conditioning, ample luggage space, and modern interiors for long-distance travel. With professional drivers and well-maintained vehicles, we ensure a safe and smooth journey across Mumbai and all major destinations. Tempo Traveller rental pricing in Mumbai typically starts from around ₹18 to ₹30 per km depending on seating capacity and vehicle type, along with customizable local packages. We offer flexible booking options including one-way trips, round trips, corporate tours, and pilgrimage travel with transparent pricing and no hidden charges. With 24/7 availability and easy booking, Royal Route Cab is your trusted choice for Tempo Traveller rental in Mumbai.",

"topPlaces": [
  {
    "title": "Tempo Traveller On Rent Mumbai",
    "description": "Tempo Traveller on rent in Mumbai is a popular choice for group travel, family vacations, corporate outings, and sightseeing tours. With spacious seating and modern amenities, it provides a comfortable travel experience for both local and outstation journeys."
  },
  {
    "title": "Tempo Traveller Rental Service Mumbai",
    "description": "Tempo Traveller rental services in Mumbai offer convenient transportation solutions for large groups traveling together. The vehicle is ideal for family gatherings, school trips, corporate events, and holiday tours."
  },
  {
    "title": "Tempo Traveller with Driver Mumbai",
    "description": "Tempo Traveller with driver services in Mumbai ensure a safe and hassle-free travel experience. Professional chauffeurs help passengers enjoy their journey comfortably while focusing on their travel plans."
  },
  {
    "title": "Mumbai Airport Tempo Traveller Rental",
    "description": "Mumbai Airport Tempo Traveller rental services are perfect for groups arriving or departing together. The vehicle provides ample seating and luggage space, making airport transfers convenient and comfortable."
  },
  {
    "title": "Luxury Tempo Traveller Mumbai",
    "description": "Luxury Tempo Traveller rentals in Mumbai feature premium interiors, comfortable seating, air conditioning, and additional amenities. They are ideal for weddings, corporate travel, and VIP group transportation."
  },
  {
    "title": "Tempo Traveller for Outstation Trips from Mumbai",
    "description": "Tempo Traveller is widely preferred for outstation trips from Mumbai to destinations such as Lonavala, Pune, Mahabaleshwar, Nashik, and Goa. It offers a comfortable and enjoyable journey for groups traveling together."
  },
  {
    "title": "Corporate Tempo Traveller Rental Mumbai",
    "description": "Corporate Tempo Traveller rental services in Mumbai are suitable for employee transportation, conferences, team outings, and business events. The spacious vehicle allows teams to travel together comfortably."
  },
  {
    "title": "Tempo Traveller for Family Trips Mumbai",
    "description": "Families planning vacations or local sightseeing in Mumbai often choose Tempo Traveller rentals because of the vehicle’s spacious seating capacity and comfortable travel experience for all age groups."
  },
  {
    "title": "Affordable Tempo Traveller Hire Mumbai",
    "description": "Affordable Tempo Traveller hire in Mumbai provides an economical transportation solution for large groups. It combines comfort, convenience, and value for money for various travel requirements."
  },
  {
    "title": "Best Tempo Traveller Service Mumbai",
    "description": "The best Tempo Traveller services in Mumbai focus on safety, reliability, and passenger comfort. They are commonly used for airport transfers, group tours, weddings, corporate travel, and outstation journeys."
  }
],






services: [
  {
    name: "Tempo Traveller on Rent Mumbai",
    description: "Tempo Traveller on rent Mumbai offers spacious and comfortable travel for group journeys, family trips, and corporate outings. Designed for long-distance and city travel, these vehicles ensure ample seating and luggage space. Professional drivers and well-maintained vehicles enhance the experience. It guarantees a smooth and enjoyable group travel experience."
  },
  {
    name: "Tempo Traveller Rental Mumbai",
    description: "Tempo traveller rental Mumbai provides flexible travel solutions for groups with different seating capacities. This service is ideal for tours, events, and outstation trips. Clean interiors and comfortable seating ensure convenience. It ensures a reliable and comfortable journey."
  },
  {
    name: "Tempo Traveller Cab Service Mumbai",
    description: "Tempo traveller cab service Mumbai offers reliable transportation for group travel needs. This service is suitable for family functions, corporate trips, and tourist travel. Professional drivers ensure safe journeys. It guarantees a hassle-free experience."
  },
  {
    name: "Tempo Traveller Booking Mumbai",
    description: "Tempo traveller booking Mumbai allows customers to reserve their vehicle easily with flexible options. Travelers can choose seating capacity, pickup location, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Tempo Traveller Hire Mumbai",
    description: "Tempo traveller hire Mumbai offers convenient rental options for group travel. This service is ideal for weddings, picnics, and business trips. Spacious seating and comfortable interiors enhance the journey. It ensures a pleasant travel experience."
  },
  {
    name: "Tempo Traveller Price Mumbai",
    description: "Tempo traveller price Mumbai varies based on seating capacity, travel distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and luxury options. It helps in planning travel efficiently. It ensures value for money."
  },
  {
    name: "Tempo Traveller Fare Mumbai",
    description: "Tempo traveller fare Mumbai is designed to be competitive for group travel. Fare depends on route, vehicle type, and travel plan. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "12 Seater Tempo Traveller Mumbai",
    description: "12 seater tempo traveller Mumbai is ideal for small groups and families seeking comfortable travel. This vehicle offers adequate space and seating for short and long trips. Professional drivers ensure safe journeys. It ensures a smooth ride."
  },
  {
    name: "17 Seater Tempo Traveller Mumbai",
    description: "17 seater tempo traveller Mumbai is perfect for large groups and corporate outings. Spacious seating and luggage capacity make it suitable for long-distance travel. Ideal for tours and events. It ensures a comfortable and enjoyable journey."
  },
  {
    name: "Luxury Tempo Traveller Mumbai",
    description: "Luxury tempo traveller Mumbai offers premium travel experience with pushback seats, AC, and modern interiors. This service is ideal for corporate clients and luxury group travel. Comfortable seating enhances long journeys. It guarantees a premium experience."
  },
  {
    name: "AC Tempo Traveller Mumbai",
    description: "AC tempo traveller Mumbai provides air-conditioned comfort for group travel in all weather conditions. This service ensures a pleasant travel experience during long journeys. Suitable for families and tourists. It ensures a relaxed ride."
  },
  {
    name: "Tempo Traveller for Outstation Mumbai",
    description: "Tempo traveller for outstation Mumbai offers reliable long-distance travel for group trips. This service is ideal for tours, pilgrimages, and vacations. Vehicles are maintained for highway performance. It ensures a safe and comfortable journey."
  },
  {
    name: "Tempo Traveller for Family Trip Mumbai",
    description: "Tempo traveller for family trip Mumbai is perfect for group vacations and family outings. Spacious seating and comfort make travel enjoyable. This service ensures convenience and safety for all passengers. It guarantees a memorable trip."
  },
  {
    name: "Cheap Tempo Traveller Mumbai",
    description: "Cheap tempo traveller Mumbai offers budget-friendly options for group travel without compromising comfort. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Tempo Traveller Service Mumbai",
    description: "Best tempo traveller service Mumbai ensures top-quality vehicles and professional drivers for group travel. This service focuses on comfort, safety, and customer satisfaction. Multiple seating options are available. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Tempo Traveller on Rent Mumbai", "Tempo Traveller Rental Mumbai"],
  ["Tempo Traveller Cab Service Mumbai", "Tempo Traveller Booking Mumbai"],
  ["Tempo Traveller Hire Mumbai", "Tempo Traveller Price Mumbai"],
  ["Tempo Traveller Fare Mumbai", "12 Seater Tempo Traveller Mumbai"],
  ["17 Seater Tempo Traveller Mumbai", "Luxury Tempo Traveller Mumbai"],
  ["AC Tempo Traveller Mumbai", "Tempo Traveller for Outstation Mumbai"],
  ["Tempo Traveller for Family Trip Mumbai", "Cheap Tempo Traveller Mumbai"],
  ["Best Tempo Traveller Service Mumbai", "Tempo Traveller on Rent Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Spacious Tempo Traveller on Rent in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers comfortable Tempo Traveller rental in Mumbai, ideal for group travel, family trips, and corporate outings."
  },
  {
    WhyChooseheading: "Perfect for Group Travel",
    WhyChoosedescription: "Tempo Traveller is designed for 9, 12, 14, 17 seater groups with ample legroom and luggage space for a relaxed journey."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in city and highway routes, ensuring safe and smooth group travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for Tempo Traveller rental including all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Tempo Traveller rental service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Tempo Travellers are regularly serviced, sanitized, and maintained for a comfortable group travel experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book Tempo Traveller for local Mumbai trips, airport transfers, tours, or outstation journeys with customizable packages."
  },
  {
    WhyChooseheading: "Trusted Group Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Tempo Traveller rental in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide Tempo Traveller on rent in Mumbai?", answer: "Yes, Royal Route Cabs offers Tempo Traveller rental services in Mumbai for local and outstation travel." },
  { question: "What seating options are available?", answer: "We provide 9, 12, 14, and 17 seater Tempo Travellers." },
  { question: "Is Tempo Traveller suitable for long-distance travel?", answer: "Yes, Tempo Traveller is ideal for long-distance group travel due to its comfort and space." },
  { question: "Is rental available 24 hours?", answer: "Yes, our Tempo Traveller rental service operates 24/7." },
  { question: "Do you provide driver with Tempo Traveller?", answer: "Yes, all rentals include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport pickup with Tempo Traveller?", answer: "Yes, we offer Mumbai airport pickup and drop services for groups." },
  { question: "Can I book for one-day trips?", answer: "Yes, we provide one-day, multi-day, and outstation booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant Joshi",
    feedback: "Tempo Traveller on rent in Mumbai from Royal Route Cabs was very spacious and comfortable. Our group travel was smooth and well-coordinated throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "Excellent experience booking a Tempo Traveller in Mumbai. The vehicle was clean, well-maintained, and perfect for our family and friends trip.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/tempo-traveller-on-rent-mumbai.jpg", // replace if needed
  "description": "Book Tempo Traveller on rent in Mumbai with Royal Route Cabs for group travel, family trips, and outstation journeys. Available in 12-seater, 17-seater, AC, and luxury options with 24x7 reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "18", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/tempo-traveller-on-rent-mumbai"
  }
};




  return (
    <div>

<Helmet>
  <title>Tempo Traveller on Rent Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Tempo Traveller on rent in Mumbai with Royal Route Cabs. Ideal for group travel, family tours, and outstation trips. Available in 12, 17 seater AC & luxury vehicles."
  />

  <meta
    name="keywords"
    content="tempo traveller on rent mumbai, tempo traveller rental mumbai, tempo traveller cab service mumbai, tempo traveller booking mumbai, tempo traveller hire mumbai, tempo traveller price mumbai, tempo traveller fare mumbai, 12 seater tempo traveller mumbai, 17 seater tempo traveller mumbai, luxury tempo traveller mumbai, ac tempo traveller mumbai, tempo traveller for outstation mumbai, tempo traveller for family trip mumbai, cheap tempo traveller mumbai, best tempo traveller service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentmumbai;